module.exports = __webpack_public_path__ + "media/images/ftux-widget-bg-0672c31c8c22f509743f99b2b003bb8c.svg";